import React from "react";

export function StepSource({ setMode }) {
  return (
    <div className={"flex flex-col gap-3"}>
      <div className={"font-medium"}>Where do you want to import from?</div>
      <div className={"grid grid-cols-2 gap-3"}>
        <div
          className={
            "bg-blue-100 rounded hover:bg-blue-200 cursor-pointer p-5 flex items-center justify-center flex flex-col gap-3"
          }
          onClick={() => setMode("bank")}
        >
          <span
            className="fa fa-bank text-blue-900"
            style={{ fontSize: 50 }}
          ></span>
          <div>From my bank</div>
        </div>
        <div
          className={
            "bg-blue-100 rounded hover:bg-blue-200 cursor-pointer p-5 flex items-center justify-center flex flex-col gap-3"
          }
          onClick={() => setMode("file")}
        >
          <span
            className="fa fa-file text-blue-900"
            style={{ fontSize: 50 }}
          ></span>
          <div>From a file</div>
        </div>
      </div>
    </div>
  );
}
